import React from 'react';
import { Text, Wizard } from '@lana-ui/common';
import { TextLogin } from '@lana-ui/login';
import LoadingSpinner from '@helpers/LoadingSpinner';
import PersonalData from '../Components/Form/PersonalData';
import '../Statics/Scss/Pages/datos-personales.scss';
import ProteccionDatosPersonales from '../Components/Common/banner/ProteccionDatosPersonales';
import { steps } from '../Config/CheckoutSteps';
import { PageViewTrackAndLogData } from '../Config/TrackAndLogData';
import { useEffect } from 'react';
import { trackCustomEventError } from '../Helpers/DataDog';
import Progress from '../Components/Common/common/src/progress/Progress';
import PhonesBanner from '../Components/Common/banner/PhonesBanner';

const DatosPersonales = ({ state, send, isLoading }) => {

    useEffect(() => {
        PageViewTrackAndLogData('formulario_datos_personales', state.context.planCampania.descripcion);
        if (!state.context.formaDeContacto || !state.context.canalDeVenta) {
            send('ERROR');
        }

        window.scrollTo(0, 180);
        window.addEventListener('message', handleMessageReceived);
        return () => {
            window.removeEventListener('message', handleMessageReceived);
        };
    }, []);

    const handleMessageReceived = (event) => {
        const eventData = event?.data?.data;
        const rta = eventData?.Codrta;
        rta && trackCustomEventError('Checkout - Evento de procesamiento de pago recibido en formulario de Datos personales', eventData);
    };

    return (
        <LoadingSpinner isLoading={isLoading}>
            <div className="progress-steps">
                <Wizard activeStep={2} steps={steps} />
                <div className="progress-steps__container">
                    <Progress currentNumber={steps.step_2.number} amountTotalNumbers={Object.values(steps).length} />
                    <div className="progress-steps__container__data">
                        <Text size="4xs" className="--arial --font-bold">
                            {steps.step_2.text}
                        </Text>
                        <Text size="5xs">Próximo paso: {steps.step_3.text}</Text>
                    </div>
                </div>
            </div>
            <section className="checkout-step-2">
                <TextLogin
                    title={
                        <>
                            ¡Hola! Para la facturación <br /> necesitamos los siguientes datos:{' '}
                        </>
                    }
                >
                    <Text as="p" size="4xs">
                        Los datos están protegidos y no serán publicados
                    </Text>
                </TextLogin>

                <PersonalData state={state} send={send} />

                <PhonesBanner />

                <ProteccionDatosPersonales />
            </section>
        </LoadingSpinner>
    );
};

export default DatosPersonales;
